import React from 'react';
import FlippingBookEmbed from '../FlippingBookEmbed';
import IssuuEmbed from '../IssuuEmbed';

interface PublicationEmbedProps {
  src: string;
  height?: string;
  provider?: 'flippingbook' | 'issuu' | 'auto';
}

export const PublicationEmbed: React.FC<PublicationEmbedProps> = ({
  src,
  height = '1000px',
  provider = 'auto'
}) => {
  const detectProvider = (url: string): 'flippingbook' | 'issuu' => {
    if (url.includes('issuu.com')) return 'issuu';
    return 'flippingbook';
  };

  const actualProvider = provider === 'auto' ? detectProvider(src) : provider;

  if (actualProvider === 'issuu') {
    return <IssuuEmbed src={src} height={height} />;
  }

  return <FlippingBookEmbed src={src} height={height} />;
};

export default PublicationEmbed;
